<script>
  import Icon from './Icon.svelte';

  /** @type {string} */
  export let type = 'primary';

  /** @type {any} */
  export let buttonType = 'button';

  /** @type {string?} */
  export let icon = null;

  /** @type {string?} */
  export let modalTarget = null;

  export let click = () => {};

  export let dismissModal = false;

  export let disabled = false;

  export let label;

  export let additionalClasses = '';
</script>

<button
  aria-label={label}
  type={buttonType}
  class="btn btn-{type} m-1 {additionalClasses}"
  {disabled}
  on:click={click}
  {...dismissModal ? { 'data-bs-dismiss': 'modal' } : {}}
  {...modalTarget ? { 'data-bs-toggle': 'modal', 'data-bs-target': `#${modalTarget}` } : {}}
>
  {#if icon}
    <Icon {icon} additionalClasses="me-1"></Icon>
  {/if}
  <slot></slot>
</button>

<style>
  .btn {
    --bs-btn-border-color: transparent !important;
    --bs-btn-hover-border-color: transparent !important;
    --bs-btn-active-border-color: transparent !important;
    --bs-btn-disabled-border-color: transparent !important;
    --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), 0.5);
  }

  .btn-primary {
    --bs-btn-color: var(--black);
    --bs-btn-bg: var(--gold2);

    --bs-btn-hover-color: var(--black);
    --bs-btn-hover-bg: var(--gold5);

    --bs-btn-active-color: var(--black);
    --bs-btn-active-bg: var(--gold5);
    --bs-btn-focus-shadow-rgb: var(--gold5-rgb);

    --bs-btn-disabled-color: var(--black);
    --bs-btn-disabled-bg: var(--gold2);
  }

  .btn-secondary {
    --bs-btn-color: var(--white);
    --bs-btn-bg: var(--grey-35);

    --bs-btn-hover-color: var(--white);
    --bs-btn-hover-bg: var(--grey-50);

    --bs-btn-active-color: var(--white);
    --bs-btn-active-bg: var(--grey-35);
    --bs-btn-focus-shadow-rgb: var(--grey-35-rgb);

    --bs-btn-disabled-color: var(--white);
    --bs-btn-disabled-bg: var(--grey-35);
  }

  .btn-transparent {
    --bs-btn-color: var(--grey-60);
    --bs-btn-hover-color: var(--white);
    --bs-btn-bg: transparent;
    --bs-btn-active-border-color: var(--black);
    font-size: 40px;
  }

  button {
    font-size: 0.95rem;
    padding: 9px 30px;
    border-radius: 20px;
  }

  .btn-link {
    font-size: 1rem;
    padding: 8px 0px;
    color: var(--white);
  }

  .btn-link:hover {
    color: var(--grey-60);
  }
</style>
